<template>
  <div>
    <!-- Dashboard Preferences -->
    <v-row>
      <v-col cols="12" md="4" class="d-none">
        <jcdc-card>
          <jcdc-headline size="h5" title="Notifications" />
          <p></p>
        </jcdc-card>
      </v-col>
      <v-col cols="12" md="8">
        <jcdc-headline size="h3" title="Application Links" />
        <p>
          Choose which shortcuts you would like displayed on your dashboard.
        </p>
        <jcdc-dual-list-box
          :key="loadingPreferences"
          :item-list="dashboardLinks"
          move-all
          save-btn
          active-title="Displayed"
          inactive-title="Removed"
          :loading="loadingPreferences"
          :error="saveError"
          :unsaved="preferencesEdited"
          @save="updateDashboardPreferences($event)"
          @change="$store.commit('preferences/SET_EDITED_PREF', !!$event)"
        />
      </v-col>
    </v-row>
    <jcdc-flash-confirm ref="prefConfirm" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {
  JcdcCard,
  JcdcDualListBox,
  JcdcFlashConfirm,
  JcdcHeadline,
} from '@/components/jcdc/index'

export default {
  name: 'PreferencesPage',
  components: {
    JcdcCard,
    JcdcHeadline,
    JcdcDualListBox,
    JcdcFlashConfirm,
  },
  beforeRouteUpdate(to, from, next) {
    this.routeGuard(to, from, next)
  },
  beforeRouteLeave(to, from, next) {
    this.routeGuard(to, from, next)
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('preferences', [
      'dashboardLinks',
      'loadingPreferences',
      'preferencesEdited',
      'saveError',
    ]),
  },
  methods: {
    ...mapActions('preferences', ['updateDashboardPreferences']),
    routeGuard(to, from, next) {
      if (this.preferencesEdited) {
        this.$refs.prefConfirm
          .show({
            message: `Are you sure you want exit this page?
              You have unsaved changes.`,
            okButton: 'Exit Without Saving',
            cancelButton: 'Keep Editing',
          })
          .then((ok) => {
            if (ok) next()
            else next(false)
          })
      } else {
        next()
      }
    },
  },
}
</script>
